import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdArrowBackIos, MdClose, MdDateRange, MdDownload, MdHistory, MdReport, MdUpload } from "react-icons/md";
import Select_on_off from "../../components_root/select_on_off.jsx";
import { PiBooks } from "react-icons/pi";
import Ledger_accounts_reports_profile from "../../company_root/staff_account_root/ledger_accounts_reports_profile.jsx";
import { No_transactions } from "../../components_root/no_transactions.jsx";
import { Verify_accountgroup } from "../Verify_accountgroup.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Cash_books() {
    const [zero_balance, setZero_balance] = useState(true);
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [company, setCompany] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading_banner, setIsLoading_banner] = useState(true);
    const [reportsrdata, setReportsData] = useState([]);
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
useEffect(() => {
    const select_company_uid = Cookies.get("select_company_uid");
    setIsLoading2(true);

    if (!select_company_uid) {
        console.error("No company selected");
        setIsLoading2(false);
        return;
    }

    const accountsQuery = query(
        collection(db, servicetablename, select_company_uid, "ledger_accounts"),
        orderBy("date_time", "desc")
    );

    const unsubscribe = onSnapshot(
        accountsQuery,
        async (snapshot) => {
            try {
                const results = await Promise.all(
                    snapshot.docs.map(async (accDoc) => {
                        const accData = accDoc.data();

                        // 🔹 Verify account type
                        let account_type = accData.account_type;

                        const masterRef = collection(
                            db,
                            "accounting_groups_list_master"
                        );
                        const masterQuery = query(
                            masterRef,
                            where("groupid", "==", accData.account_type)
                        );

                        const masterSnap = await getDocs(masterQuery);
                        if (!masterSnap.empty) {
                            account_type =
                                masterSnap.docs[0].data()?.account_type ||
                                accData.account_type;
                        }

                        // 🔹 account guid
                        const accNo = accData.accountguid;

                        const ledgerQuery = query(
                            collection(
                                db,
                                servicetablename,
                                select_company_uid,
                                "cash_books_accounting"
                            ),
                            where("accountguid", "==", accNo),
                            orderBy("date_time", "desc"),
                            limit(1)
                        );

                        const ledgerSnap = await getDocs(ledgerQuery);

                        const lastLedgerDoc = !ledgerSnap.empty
                            ? ledgerSnap.docs[0]
                            : null;

                        const lastLedger = lastLedgerDoc
                            ? {
                                  ledger_id: lastLedgerDoc.id,
                                  ...lastLedgerDoc.data(),
                              }
                            : null;

                        return {
                            id: accDoc.id,
                            ...accData,
                            account_type,
                            last_ledger: lastLedger,
                            last_ledger_date_time:
                                lastLedger?.date_time ?? null,
                            sort_balance: lastLedger?.balance ?? 0,
                        };
                    })
                );

                const filteredResults = zero_balance
                    ? results
                    : results.filter(
                          (item) => Number(item.sort_balance) > 0
                      );

                setReportsData(
                    filteredResults.sort(
                        (a, b) => b.sort_balance - a.sort_balance
                    )
                );
            } catch (err) {
                console.error("Error:", err);
            } finally {
                setIsLoading2(false);
            }
        },
        (error) => {
            console.error("Error fetching accounts:", error);
            setIsLoading2(false);
        }
    );

    return () => unsubscribe();
}, [zero_balance]);



    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const openEditVoucher = (uid) => {
        navigate(`?page=cash_books_statement&accountguid=${uid}`);   // update URL

    };
    const verifyGroup = async (groupid) => {
        try {
            const res = await Verify_accountgroup(groupid);

            return res?.success && res.data?.account_type
                ? res.data.account_type
                : groupid;
        } catch (error) {
            console.error("verifyGroup error:", error);
            return groupid;
        }
    };
    return (
        <div >
            <div className="items-back">
                <div className="b-bottom">
                    <table>
                        <tr>
                            <td ><div

                                className="button-ui0 text-h2 bold p-2"
                            >
                                <PiBooks className="icon" />Cash Books
                            </div></td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="post-container p-11">

                    <table>
                        <tr><td><div className="text-h2 bold">Ledger show {reportsrdata.length}</div></td>
                            <td width={75}><Select_on_off checked={zero_balance} onChange={(e) => { setZero_balance(!zero_balance) }} /></td>
                        </tr>
                    </table>
                </div>
                <div className="post-container">

                    <div className="post_div">
                        <div className="ui-grid_voucher">

                            {IsLoading2 ? (
                                <></>
                            ) : reportsrdata.length === 0 ? (
                                <No_transactions message="Cashbook" />
                            ) : (
                                <>
                                    {window.innerWidth > 768 ? (
                                        // ============================
                                        // DESKTOP VIEW: Single Row Table
                                        // ============================
                                        <table className="voucher-table-desktop">
                                            <thead>
                                                <tr>
                                                    <th>Account No.</th>
                                                    <th>Date & Time</th>

                                                    <th>Name</th>
                                                    <th>Type</th>
                                                    <th className="text-r">Balance</th>
                                                    <th>Withdrawal</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportsrdata.map((row) => (

                                                    <tr key={row.accountguid} className="tr_hover">
                                                        <td width={82} title="Click: Account statement " onClick={() => openEditVoucher(row.accountguid)} className="cursor text-h3 bold p-11">{row.accountnumber || "0"}</td>
                                                        <td width={130} title="Click: Account statement" className="text-h3 cursor" onClick={() => openEditVoucher(row.accountguid)}>
                                                            {row.last_ledger_date_time?.toDate ? (
                                                                <>
                                                                    {row.last_ledger_date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.last_ledger_date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className="text-h3">Not Update</div>
                                                            )}
                                                        </td>

                                                        <td className="text-h2 fcap cursor " title="Click: Account statement" onClick={() => openEditVoucher(row.accountguid)}>{<Ledger_accounts_reports_profile accountguid={row.accountguid} />   }</td>
                                                        <td width={100} className="text-h2">   <div
                                                            className={
                                                                `  text-h3 fcap ` +
                                                                (row.account_type === "cash" ? "red bold" : "")
                                                            }
                                                        >
                                                            {
                                                                row.account_type.replaceAll("_", " ")
                                                            }
                                                        </div></td>
                                                        <td
                                                            width={80}
                                                            className="text-h2 bold text-r p-11"
                                                            style={{ color: (row?.last_ledger?.balance ?? 0) === 0 ? "#999" : "" }}
                                                        >
                                                            {row?.last_ledger?.balance == null
                                                                ? "--"
                                                                : Number(row.last_ledger.balance).toFixed(2)}
                                                        </td>

                                                        <td width={80}>
                                                            <div onClick={() => navigate("/accounting?page=cashbook_withdrawal&accountguid=" + row.accountguid)} className="button-ui green-back fcap p-11 cursor text-h2"><MdDownload className="icon" />Withdrawal</div>
                                                        </td>
                                                        {/* <td width={80}>
                                                            <div
                                                                onClick={() => navigate("/accounting?page=cashbook_deposit&accountguid=" + row.accountguid)}
                                                                className="button-ui green-back fcap cursor p-11 text-h2"><MdUpload className="icon" />deposit</div>
                                                        </td> */}

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    ) : (
                                        // ============================
                                        // MOBILE VIEW: Card UI
                                        // ============================
                                        reportsrdata.map((row) => (
                                            <div
                                                className="ui-items items-back items-back p-11 shadow hover rounded "

                                                key={row.voucherid}
                                            >
                                                <table key={row.id}>
                                                    <tbody>
                                                        <tr>
                                                            <table>
                                                                <tr onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement"> <td>
                                                                    <div className="text-h1 bold">
                                                                        {row.name || "voucher No found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement"> <td>
                                                                    <div className="text-h3">Mobile:
                                                                        {row.mobile || "No  found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr> <td>
                                                                    <div className="text-h3 text-off ">
                                                                        {row.description || "No  found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr> <td>
                                                                    <table onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement">
                                                                        <tr>
                                                                            <td>
                                                                                <div
                                                                                    className={
                                                                                        ` bold text-h2 fcap ` +
                                                                                        (row.account_type === "cashier" ? "red" : "")
                                                                                    }
                                                                                >
                                                                                    {row.account_type}
                                                                                </div>
                                                                            </td>
                                                                            <td><div className="text-h3 ">A/c:
                                                                                {row.accountguid || "No  found"}
                                                                            </div></td>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>

                                                                        <table className="b-top">
                                                                            <tr>

                                                                                <td>
                                                                                    <div className="text-h2 bold">Balance
                                                                                        ₹{row.last_ledger.balance || "0"}/-
                                                                                    </div>
                                                                                </td>
                                                                                <td width={130} className='text-h3 text-r'>
                                                                                    {row.date_time?.toDate ? (
                                                                                        <>
                                                                                            {row.last_ledger.date_time.toDate().toLocaleDateString()}{" "}
                                                                                            {row.last_ledger.date_time.toDate().toLocaleTimeString()}
                                                                                        </>
                                                                                    ) : (
                                                                                        <div className='contact-details'>No date</div>
                                                                                    )}
                                                                                </td>

                                                                            </tr>
                                                                        </table>

                                                                    </td>
                                                                </tr>

                                                            </table>



                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table className="table-fixed">
                                                    <tr>
                                                        <td>
                                                            <div onClick={() => navigate("/accounting?page=cashbook_voucher_withdrawal&accountguid=" + row.accountguid)} className="button-ui fill red-back fcap p-2 cursor text-h2"><MdDownload className="icon" />withdrawal</div>
                                                        </td>
                                                        <td>
                                                            <div title="Deposit"
                                                                onClick={() => navigate("/accounting?page=cashbook_deposit&accountguid=" + row.accountguid)}
                                                                className="button-ui fill green-back fcap cursor p-2 text-h2"><MdUpload className="icon" />deposit</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        ))
                                    )}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
